import { Component, Input } from '@angular/core';
import { WhereDoIRegisterCard } from 'src/app/model/card/where-do-i-register-card';

@Component({
  selector: 'app-where-do-i-register-card',
  templateUrl: './where-do-i-register-card.component.html',
  styleUrls: ['./where-do-i-register-card.component.scss']
})
export class WhereDoIRegisterCardComponent {
  @Input() whereDoIRegisterCards: WhereDoIRegisterCard[] = [];
  constructor() {}
}
